import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterArray'
})
export class FilterArrayPipe implements PipeTransform {
    public transform(arrayList: any[], filter: any): any[] {
        if (typeof filter === 'string') {
            if (filter && filter.length > 0) {
                filter = filter.toLowerCase();
                return arrayList.filter((v) =>
                    Object.keys(v).some((key, i, a) => {
                        if (typeof v[key] === 'string') {
                            return v[key].toLowerCase().indexOf(filter) > -1;
                        }
                        return false;
                    })
                );
            }
        } else if (typeof filter === 'object') {
            return arrayList.filter((v) =>
                Object.keys(filter).some((key, index) => {
                    if (filter[key] === undefined) {
                        return true;
                    }
                    if (typeof v[key] === 'string') {
                        return v[key].toLowerCase().indexOf(filter[key]) > -1;
                    }
                    return true;
                })
            );
        }

        return arrayList;
    }
}
